import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app';
import { AppConstants } from './app/app.constants';
import { startRum } from '@spotlight/shared/rum';
import { unregisterServiceWorkers } from '@spotlight/shared/legacy-service-worker';
import { SharedConstants } from './app/shared/shared.constants';
import { stripLocationPrefix } from './app/shared/navbar/location-utils';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

startRum({
  applicationId: SharedConstants.datadogRumApplicationId,
  clientToken: SharedConstants.datadogRumClientToken,
  service: 'spotlight-ui',
  env: environment.env,
  version: document.querySelector<HTMLMetaElement>('meta[name="application-version"]')?.content ?? '',
  // The APIs the app sends its auth headers to; RUM adds trace headers to the same requests.
  tracingUrls: [...(environment.urlsForAuthHeader ?? []), ...(environment.urlsForJWTHeader ?? [])],
  normalizePath: stripLocationPrefix
});

if (environment.production) {
  unregisterServiceWorkers();
}

const hostname = location.hostname;
// This is for production when the  hostname is 'spotlight.cfahome.com'
let faviconUrl = AppConstants.productionFaviconUrl;

if (hostname === 'localhost') {
  faviconUrl = AppConstants.localFaviconUrl;
} else if (hostname === 'spotlight.cfaspotlighttest.cfadevelop.com' || hostname === 'spotlight.cfaspotlightdev.cfadevelop.com') {
  faviconUrl = AppConstants.qaFaviconUrl;
}

const faviconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
if (faviconLink) {
  faviconLink.href = faviconUrl;
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err));

